/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CsvError model module.
* @module model/CsvError
* @version 2020-12-7
*/
export default class CsvError {
    /**
    * Constructs a new <code>CsvError</code>.
    * CSVのエラー
    * @alias module:model/CsvError
    * @class
    * @param lineNo {Number} 行番号。< 0ならファイル全体。
    * @param code {String} エラーを表すコード
    * @param message {String} エラーを表すメッセージ
    */

    constructor(lineNo, code, message) {
        
        
        this['lineNo'] = lineNo;
        this['code'] = code;
        this['message'] = message;
        
    }

    /**
    * Constructs a <code>CsvError</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CsvError} obj Optional instance to populate.
    * @return {module:model/CsvError} The populated <code>CsvError</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CsvError();
                        
            
            if (data.hasOwnProperty('lineNo')) {
                obj['lineNo'] = ApiClient.convertToType(data['lineNo'], 'Number');
            }
            if (data.hasOwnProperty('field')) {
                obj['field'] = ApiClient.convertToType(data['field'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
    * 行番号。< 0ならファイル全体。
    * @member {Number} lineNo
    */
    'lineNo' = undefined;
    /**
    * フィールド名。
    * @member {String} field
    */
    'field' = undefined;
    /**
    * エラーを表すコード
    * @member {String} code
    */
    'code' = undefined;
    /**
    * エラーを表すメッセージ
    * @member {String} message
    */
    'message' = undefined;




}
